export const BASE_URL = "https://balachekapde-c3ae66c6a78f.herokuapp.com";
// export const BASE_URL = "http://localhost:8081";
